import { formatString, userFullName } from "./common";

export const parseConsentForm = (formHtml, submissionValues, isSubmitted) => {
  const submittedValues = submissionValues || {}
  // const clientDetails = data?.formClient;

  const gender = null;
  let fieldIndex = 0;
  return formHtml?.replace(/{{(.*?)}}/g, (_, fieldKey) => {
    fieldIndex += 1;
    const key = `${fieldKey}_[${fieldIndex}]`

    const shortcodeParts = key.split("_");
    const field = shortcodeParts[0];
    const fieldType = shortcodeParts[1];

    const value = submittedValues[key];
    
    if(fieldKey === "client_fullname") {
      return inputField({ type: "text", value, key, isSubmitted });
    } else if(fieldKey === "client_dob") {
      return inputField({ type: "date", value, key,isSubmitted });
    }

    if(fieldType === "radio") {
      const fieldOptions = shortcodeParts[2] ? shortcodeParts[2].split(",") : [];
      return inputField({ type: fieldType, key, options: fieldOptions, value, isSubmitted });
    } if(fieldType === "checkbox") {
      const checkboxValue = shortcodeParts[2] || "";
      return inputField({ type: fieldType, key, checkboxValue, value, isSubmitted });
    } else if(fieldType === "repeater") {
      console.log("repeater", fieldType)
      const fieldOptions = shortcodeParts[2] ? shortcodeParts[2].split(",") : [];
      return inputField({ type: fieldType, key, options: fieldOptions, value, isSubmitted });
    } else {
      return inputField({ type: fieldType, key, value, isSubmitted });
    }
  });
}


const inputField = ({type = "text", value = "", key, options = [], isSubmitted = false}) => {
  if(!key) {
    return null;
  }

  if(type === "textarea") {
    return `<textarea value="${value}" class="consent-form-input input-textarea" name="${key.trim()}" ${isSubmitted ? "readonly='true'" : ""}></textarea>`
  }

  if (type === "radio") {
    return options.map(option => {
      const isChecked = value === option ? "checked" : "";
      const isDisabled = isSubmitted ? "disabled" : "";
      return `
        <label>
          <input 
            type="radio" 
            name="${key.trim()}" 
            value="${option}" 
            class="consent-form-input"
            ${isChecked}
            ${isDisabled}
          > ${option}
        </label>
      `;
    }).join("");
  }

  if (type === "checkbox") {
    const isChecked = value === "on" ? "checked" : "";
    const isDisabled = isSubmitted ? "disabled" : "";
    return `
      <label>
        <input 
          type="checkbox" 
          name="${key.trim()}" 
          ${isChecked} 
          ${isDisabled}
        >
      </label>
    `;
  }

  if (type === "repeater") {
    const hasValues = Array.isArray(value) && value.length > 0;
    const repeaterValues = hasValues ? value : [{}];
    const keyName = key.trim();
  
    const fieldsHtml = repeaterValues.map((item, index) => `
      <div class="repeater-item">
        ${
          options.map((option) => `
            <input 
              type="text" 
              name="${keyName}[${index}][${option}]" 
              value="${item[option] || ''}" 
              placeholder="${formatString(option)}"
              class="consent-form-input"
              data-option="${option}"
              ${hasValues ? "readonly" : ""}
            >
          `).join("")
        }
        <button type="button" class="remove-btn btn btn-danger p-1" ${isSubmitted ? "disabled" : ""}>Remove</button>
      </div>
    `).join("");
  
    return `
      <div class="repeater-wrapper" data-key="${keyName}">
        ${fieldsHtml}
        <button type="button" class="add-btn btn btn-primary" ${isSubmitted ? "disabled" : ""}>Add</button>
      </div>
    `;
  }
  

  return `<input type="${type}" value="${value}" class="consent-form-input" name="${key.trim()}" ${isSubmitted ? "readonly='true'" : ""} >`
}